import React, { Fragment } from "react";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles, withTheme } from "@material-ui/core/styles";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import IndeterminateCheckBox from '@material-ui/icons/IndeterminateCheckBox';
import { getSvgIcons, getThemeColorByIconName } from "../../../../modules/Dispatch/utils/iconsUtil";
import { compose } from "recompose";
import ListSearch from "../../../../common/MUI/ListSearch";

const styles = theme => ({
    filterContainer:{
        padding: theme.spacing.unit,
        backgroundColor: theme.ModalBGColor,
        overflow:"hidden",
        '& label$checkbox_root$formControlLabel':{
            display:"flex",
            color: theme.TextColor
        },
    },
    formGroup:{
        backgroundColor: theme.ModalBGColor,
        maxWidth: 240,
        padding:"4px 8px 4px 0",
        overflowY:"auto",
        display:"flex",
        maxHeight:"150px",
        flexWrap:"nowrap"
    },
    formControlRoot:{
      margin:0,
      padding:"4px 0",
    },
    formControlLabel:{
        display:"inline-flex",
        color: theme.TextColor,
        fontSize: theme.textFontSize
    },
    checkboxRoot:{
        padding:4,
        color: theme.gridIconBorderColor
    },
    iconClass:{
        paddingRight:4,
        fontSize:16,
        color: theme.iconColor,
        display:'flex',
        alignSelf:'center'
    },
    svgIconClass:{
        paddingLeft:4
    },
    optionTextClass:{
        lineHeight: "24px"
    },
    noOption:{
        padding:16,
        color: theme.TextColor
    },
    labelDisabled:{
        cursor:"not-allowed"
    },
    formControlLabelDisabled:{
        color:"inherit",
        opacity:"0.5",
        pointerEvents: "none"
    },
    formControlLabelColor: {
        fontSize: "12px",
        color: theme.TextColor,
        marginTop:"5px"
    },
    checkbox_root: {
        padding: "5px",
        paddingLeft:"0px",
        verticalAlign: "middle",
        height: "100%",
        color: theme.gridIconBorderColor,
        '&$checkbox_checked': {
          color: theme.HeaderSelectedText
        }
    },
    checkbox_checked: {
    },
    checkbox_disabled:{

    },
    formLabel:{
        margin:0,
        backgroundColor: theme.ModalBGColor,
        paddingBottom: "0",
        listStyleType:"none",
        display:"flex",
        cursor:"pointer",
        paddingTop:"5px",
        '& $formControlLabelDisabled,& $checkbox_disabled':{
          color:"inherit",
          opacity:"0.5",
        }
    },
})

const getOptionIconByType = ({ option, classes, theme }) => {
  if (option.icon) {
    return <i className={`${option.icon} ${classes.iconClass}`} />;
  } else if (option.svgIcon) {
    const {backgroundColor, borderColor=""} = getThemeColorByIconName(option, theme);
    return (
      <div className={`${classes.iconClass} ${classes.svgIconClass}`}>
        {getSvgIcons({
          iconName: option.svgIcon,
          backgroundColor,
          borderColor,
          size: option?.iconStyles?.size
        })}
      </div>
    );
  }
  return null;
};

const StaticOptions = props => {
    const { classes } = props;
    const isSelectAllDisabled = props.options.length === 0;
    const hasSelections = props.options.some(option=>props.isOptionSelected(option.value));

    const getLabel = (option) => {
      return (
        <Fragment>
          {getOptionIconByType({option, classes, theme: props.theme})}
          <span className={classes.optionTextClass}> {option.text}</span>
        </Fragment>
      );
    };
    

    return (
        <div className={classes.filterContainer}>
        <ListSearch onSearch={props.onSearch} value={props.searchTerm} />

        <div className={`${isSelectAllDisabled ? classes.labelDisabled : ""}`}>
            <div onClick={()=>props.onSelectAll(!hasSelections)} className={`${classes.formLabel} ${isSelectAllDisabled ? classes.formControlLabelDisabled : ''}`}>
                <span className={`${classes.checkbox_root} ${hasSelections ? classes.checkbox_checked :'' }`}>
                    {hasSelections ?
                        <IndeterminateCheckBox color="primary"/> :
                        <CheckBoxOutlineBlankIcon />
                    }
                </span>
                <span className={classes.formControlLabelColor}>{  hasSelections ? "CLEAR ALL" : "SELECT ALL"}</span>
            </div>
        </div>

        <FormGroup className={`${classes.formGroup} customScroll`}>
            { props.options.length ? props.options.map(option => {
                const isSelected =props.isOptionSelected(option.value);
                return (
                    <FormControlLabel
                        key={option.value}
                        control={
                            <Checkbox
                                checked={isSelected}
                                color={isSelected ? "primary" :"secondary"}
                                onChange={(event) => props.onOptionSelected(option.value, event.target.checked)}
                                value={option.value}
                                classes={{
                                    root: classes.checkboxRoot
                                }}
                            />
                            }
                        label={
                            getLabel(option)
                        }
                        classes={{
                            root: classes.formControlRoot,
                            label: classes.formControlLabel
                        }}
                    />
                    )
                }) : <div className={classes.noOption}>NO OPTIONS</div>
            }
        </FormGroup>
        </div>
    )
}


export default compose(withStyles(styles),withTheme())(StaticOptions);